import { useNavigate } from "react-router-dom";

const STATS = [
  { num: "80+", label: "深度反转档案" },
  { num: "12+", label: "领域持续深扒" },
  { num: "周更", label: "专题稳定产出" },
];

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden">
      {/* 顶部分类引导条 */}
      <div className="border-b border-background-200/60 bg-background-50">
        <div className="mx-auto flex max-w-7xl flex-col items-start gap-3 px-4 py-3 md:flex-row md:items-center md:justify-between md:px-6">
          <p className="flex items-center gap-2 text-sm text-foreground-600">
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-primary-500" />
            正在实时追踪全网「表里不一」现场
          </p>
          <div className="flex flex-wrap gap-2">
            {["人设反转", "身份揭秘", "滤镜打假", "言行双标", "打脸实录"].map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => navigate(`/?q=${encodeURIComponent(t)}`)}
                className="whitespace-nowrap cursor-pointer rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                #{t}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-7">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-user-unfollow-line" /> 反差吃瓜 · 人设显微镜
          </p>
          <h1 className="mt-5 font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-5xl">
            人设越完美，
            <br />
            反转越<em className="not-italic text-primary-600">锋利</em>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-700 md:text-lg">
            反差吃瓜局只做一件事——把「台前的人设」与「台后的真相」并排摆在一起，给你看清当事人最真实的一面。深扒人设反转、身份揭秘、言行双标与前后对比，讲逻辑、讲证据、理性吃瓜。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => navigate("/#cases")}
              className="whitespace-nowrap cursor-pointer rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              进入反转档案
            </button>
            <button
              type="button"
              onClick={() => navigate("/#rank")}
              className="whitespace-nowrap cursor-pointer rounded-full border border-foreground-900/15 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-foreground-900/30 hover:bg-background-100"
            >
              查看本周热度榜
            </button>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200/70 bg-background-50 p-4">
                <dt className="order-2 mt-1 text-xs text-foreground-500">{s.label}</dt>
                <dd className="font-heading text-2xl font-black text-foreground-950">{s.num}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20of%20a%20cracked%20spotlight%20and%20falling%20masks%20with%20two%20opposing%20silhouettes%20in%20warm%20cream%20paper%2C%20vermilion%20red%20and%20amber%20gold%20accents%2C%20high%20contrast%20minimalist%20graphic%20design%2C%20dramatic%20unmask%20theme%2C%20high%20detail&width=1000&height=750&seq=fc-hero-01&orientation=landscape"
                alt="人设反转与身份揭秘主题的编辑部插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -left-3 -top-3 rounded-xl bg-foreground-950 px-4 py-3 text-background-50 shadow-lift md:-left-5 md:-top-4">
              <p className="text-[11px] uppercase tracking-widest text-accent-300">NOW PLAYING</p>
              <p className="mt-1 font-heading text-base font-bold">纯欲顶流·滤镜碎裂</p>
            </div>
            <div className="absolute -bottom-4 -right-2 rotate-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3 shadow-lift md:-right-4">
              <p className="text-[11px] font-semibold text-primary-600">反转进行时</p>
              <p className="mt-0.5 text-sm text-foreground-800">全平台考古热度 ↑ 96</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}